(ns ^:no-doc frontend.version)

(defonce version "2.0.1")
